import { Link } from 'react-router-dom';
import type { Movie } from '@/shared/types';
import { SmartImage } from '@/shared/ui/SmartImage';
import { cn } from '@/shared/utils/cn';

type Variant = 'landscape' | 'portrait';

export function MovieCard({ movie, variant = 'landscape' }: { movie: Movie; variant?: Variant }) {
  return (
    <Link
      data-testid="movie-card"
      data-movie-id={movie.id}
      to={`/movieflix/movie/${movie.id}`}
      className={cn(
        'relative flex-shrink-0 overflow-hidden rounded-xl border border-white/[0.08] bg-black/30 active:scale-95 transition-transform snap-start block',
        variant === 'landscape' ? 'w-[260px]' : 'w-36',
      )}
    >
      <SmartImage
        fill
        aspect={variant === 'landscape' ? '16/9' : '2/3'}
        src={variant === 'landscape' ? movie.backdrop : movie.poster}
        alt={movie.title}
        sizes={variant === 'landscape' ? '260px' : '150px'}
      />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent p-3 pt-10">
        <div className="text-white text-xs font-medium tracking-wide line-clamp-1">{movie.title}</div>
        <div className="text-white/50 text-[10px] uppercase tracking-wider">
          {movie.year} · {movie.rated}
        </div>
      </div>
    </Link>
  );
}
